import React, { useCallback } from 'react'

import { Modal } from '@clientbase/clientbase-library'
import { RenderBodyCustomerModal } from 'templates/Customers/Modals/CustomerBodyModal'

import { FormCompanyScope } from 'components/CompanySelector'

export type ModalNewCustomerProps = {
  isOpenModalNewCustomer: boolean
  setIsOpenModalNewCustomer: (isOpen: boolean) => void

  setRefresh?: React.Dispatch<React.SetStateAction<boolean>>
}

const ModalNewCustomer = ({
  isOpenModalNewCustomer,
  setIsOpenModalNewCustomer,
  setRefresh
}: ModalNewCustomerProps) => {
  const handleCloseCustomer = useCallback(async () => {
    setIsOpenModalNewCustomer(false)
  }, [])

  return (
    <Modal
      handleClose={() => handleCloseCustomer()}
      open={isOpenModalNewCustomer}
      size="large"
      width="100%"
      maxWidth="80vw"
      maxHeight="90vh"
      height="auto"
    >
      {/* SC-10999: na visão multi-empresas o cliente é criado na empresa
          escolhida no topo do formulário */}
      <FormCompanyScope>
        {(companySelector) => (
          <RenderBodyCustomerModal
            onClose={handleCloseCustomer}
            setRefresh={setRefresh}
            companySelector={companySelector}
          />
        )}
      </FormCompanyScope>
    </Modal>
  )
}

export default ModalNewCustomer
